import { h as r } from "../internals/has-own-property.js";
import { d as t } from "../internals/define-built-in.js";
import { d as i } from "../internals/date-to-primitive.js";
import { w as o } from "../internals/well-known-symbol.js";
var s = o("toPrimitive"),
  e = Date.prototype;
r(e, s) || t(e, s, i);